import InitialsCircle from "./InitialsCircle";

export default InitialsCircle;
